import selectors from '../constants/selectors';

const getMedia = (element) => element?.querySelector(selectors.MEDIA_CONTAINER) || null;

const getImage = (element) => element?.querySelector(selectors.IMAGE) || null;

const getIframe = (element) => element?.querySelector(selectors.IFRAME) || null;

export { getMedia, getImage, getIframe };
